import { render, staticRenderFns } from "./ExpenseCategoriesEdit.vue?vue&type=template&id=6f07930a&scoped=true&"
import script from "./ExpenseCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategoriesEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCategoriesEdit.vue?vue&type=style&index=0&id=6f07930a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07930a",
  null
  
)

export default component.exports